module.exports = __webpack_public_path__ + "img/icon-change-payroll-frequency.68e73d20.svg";